import { render, staticRenderFns } from "./new-customer-reward.vue?vue&type=template&id=59722216&scoped=true&lang=pug&"
import script from "./new-customer-reward.vue?vue&type=script&lang=js&"
export * from "./new-customer-reward.vue?vue&type=script&lang=js&"
import style0 from "./new-customer-reward.vue?vue&type=style&index=0&id=59722216&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59722216",
  null
  
)

export default component.exports